function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import request from 'superagent';
import _debounce from 'lodash/debounce';
var Search = /*#__PURE__*/function () {
  function Search() {
    _classCallCheck(this, Search);
    this.form = document.querySelector('.js-search-form');
    this.input = document.querySelector('.js-search-input');
    this.autocompleteContainer = document.querySelector('.js-search-autocomplete');
    this.autocompleteList = document.querySelector('.js-search-autocomplete-list');
    this.handleSearch();
    this.autocomplete();
  }
  _createClass(Search, [{
    key: "autocomplete",
    value: function autocomplete() {
      var _this = this;
      var submit = document.querySelector('.js-search-autocomplete-submit');
      submit.addEventListener('mousedown', function () {
        submit.click();
      });
      this.input.addEventListener('blur', function () {
        setTimeout(function () {
          _this.autocompleteContainer.classList.add('is-hidden');
          _this.autocompleteList.innerHTML = '';
        }, 200);
      });
      this.input.addEventListener('keyup', _debounce(function () {
        _this.handleAutocomplete();
      }, 300));
    }
  }, {
    key: "handleAutocomplete",
    value: function handleAutocomplete() {
      var _this2 = this;
      if (!this.input.value) {
        this.autocompleteContainer.classList.add('is-hidden');
        this.autocompleteList.innerHTML = '';
      } else {
        request.get('/api/v1/search/product').query({
          query: this.input.value
        }).end(function (err, res) {
          var results = JSON.parse(res.text);
          var queryCountEl = document.querySelector('.js-query-count');
          if (results.length) {
            _this2.autocompleteContainer.classList.remove('is-hidden');
          } else {
            _this2.autocompleteContainer.classList.add('is-hidden');
          }
          _this2.autocompleteList.innerHTML = '';
          results.forEach(function (item, index) {
            if (index < 4) {
              var listItem = document.createElement('li');
              var anchor = document.createElement('a');
              anchor.href = item.Link;
              anchor.innerHTML = (item.Code ? "<span>".concat(item.Code, "</span></br>") : '') + item.Title;
              listItem.appendChild(anchor);
              _this2.autocompleteList.appendChild(listItem);
            }
          });
          queryCountEl.innerHTML = results.length;
        });
      }
    }
  }, {
    key: "handleSearch",
    value: function handleSearch() {
      var _this3 = this;
      this.form.addEventListener('submit', function (e) {
        e.preventDefault();

        // this.form.action = '/products';

        _this3.form.submit();
      });
    }
  }]);
  return Search;
}();
export { Search as default };